// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12pRl","name":"styles_name__3S4La","phone":"styles_phone__3PEWe"};